// Issue #81: 未設定値の表示が画面・項目ごとに 4 パターンへ揺れていた。
//   (A) "None" 明示（MyProfile の Grade）
//   (B) 空白（MyProfile の他項目・Dashboard の p タグ列）
//   (C) "null/null" 文字列（HomePage の稼働日数・文字列連結による型強制の副作用）
//   (D) 中身のない色付き空 Tag（Dashboard の Tag 列）
// 同じ「未設定」が画面ごとに違う見え方をすると、利用者は別の状態だと受け取る。
// 表示は一律「-」に寄せる。

import { Tag } from "antd";
import React from "react";

/** 未設定を表す統一表示 */
export const NOT_SET = "-";

/**
 * 値が未設定かどうか。
 *
 * null / undefined に加えて空文字・空白のみの文字列も未設定として扱う。
 * Issue #81 が挙げた 4 パターンのうち (B) 空白は、値が null のときだけでなく
 * 空文字が入っているときにも同じ見え方になるため、両方を同じ表示へ寄せる。
 */
export const isBlankValue = (value) =>
	value === null ||
	value === undefined ||
	(typeof value === "string" && value.trim() === "");

/** 未設定なら "-"、それ以外は値をそのまま返す */
export const renderNullable = (value) =>
	isBlankValue(value) ? NOT_SET : value;

/**
 * 値があれば Tag、無ければ Tag を出さずに "-" を返す。
 *
 * 中身のない色付き Tag（パターン D）は「何かが設定されている」ように見えるため、
 * 未設定のときは Tag 自体を描画しない。
 */
export const renderNullableTag = (value, color) =>
	isBlankValue(value) ? NOT_SET : <Tag color={color}>{value}</Tag>;

/**
 * "左/右" 形式の複合値（稼働日数 "実績/総日数" など）。
 *
 * 両方とも未設定なら Tag を出さず "-"。片方だけ未設定ならその側だけ "-" にして
 * 対比が読めるようにする（"12/-"）。旧実装は文字列連結だったため未設定が
 * "null/null" とそのまま出ていた（パターン C）。
 */
export const renderNullablePairTag = (left, right, color, key) => {
	if (isBlankValue(left) && isBlankValue(right)) {
		return NOT_SET;
	}
	return (
		<Tag key={key} color={color}>
			{`${renderNullable(left)}/${renderNullable(right)}`}
		</Tag>
	);
};
